module.exports = __webpack_public_path__ + "static-v-shop/1752855439231/img/data-fiscal.a3ed015d.png";